<template>
  <div class="table-settings layout">
    <m-confirm
      ref="confirm"
      confirm="Удалить"
      reset="Отменить"
      mode="danger"
      title="Удаление настройки таблицы"
    ></m-confirm>

    <div class="layout-header">
      <div class="layout-title">
        <span v-if="id">
          Настройки таблицы
          <span class="table-name">{{ settings && settings.name }}</span>
        </span>
        <span v-else>Создать настройки таблицы</span>
      </div>
      <div class="layout-header-actions">
        <div class="layout-header-action">
          <c-button
            v-if="id"
            responsive
            label="Удалить"
            :icon="{ color: 'pink', icon: 'trash' }"
            type="with-icon"
            @click="removeTableSettings"
          />
        </div>
        <div class="layout-header-action">
          <c-button-2
            size="small"
            :responsive="true"
            icon="back"
            type="with-icon"
            label="К настройкам"
            @click="toTablesSettings"
          />
        </div>
      </div>
    </div>

    <div v-if="!id" class="table-settings__note">
      Выберите тип таблицы и настройте для неё набор столбцов, который будет отображаться по умолчанию. Также для
      отдельных должностей/ролей с помощью условий можно настроить свои наборы столбцов.
    </div>

    <div class="table-settings__content">
      <table-select v-if="!id" v-model="tableType" class="table-settings__select" :error="error"></table-select>

      <table-settings-form
        v-if="tableType"
        ref="form"
        class="table-settings__form"
        :table="tableType"
        :settings="settings"
      ></table-settings-form>

      <div
        class="table-settings__actions"
        :class="{
          fixed: bottomFixed,
        }"
      >
        <c-button class="table-settings__reset" size="large" label="Отменить" :disabled="!tableType" @click="reset" />

        <c-button
          class="table-settings__apply"
          label="Сохранить"
          color="blue"
          size="large"
          :disabled="!tableType"
          @click="submit"
        />
      </div>
    </div>

    <div ref="observer"></div>

    <top-button root=".layout"></top-button>
  </div>
</template>

<script>
import Button2 from "@/components/controls2/Button";
import Button from "@/components/controls/button";
import TopButton from "@/components/top-button";
import TableSelect from "./components/table-select";
import TableSettingsForm from "./components/table-settings-form";
import MConfirm from "@/components/modals/confirm-modal";

export default {
  name: "table-settings",
  components: {
    "c-button-2": Button2,
    "c-button": Button,
    TableSelect,
    TopButton,
    TableSettingsForm,
    MConfirm,
  },
  data() {
    return {
      id: null,
      tableType: null,
      settings: null,
      inited: false,
      error: null,
      bottomFixed: true,
    };
  },

  watch: {
    tableType() {
      this.error = null;
    },
  },

  created() {
    this.id = this.$route.params.id;

    if (this.id) {
      this.getTableSettings(this.id).then((settings) => {
        this.settings = settings;
        this.tableType = settings.section;
        this.inited = true;
      });
    } else {
      this.inited = true;
    }
  },

  mounted() {
    new IntersectionObserver(([entry]) => {
      this.bottomFixed = entry.isIntersecting;
    }).observe(this.$refs.observer);
  },

  methods: {
    getTableSettings(id) {
      this.loadingSettings = true;
      return this.$store
        .dispatch("tablesSettings/getTableSettings", {
          id,
        })
        .then((res) => res.model);
    },

    removeTableSettings() {
      this.$refs.confirm.open({
        text: `Настройка таблицы <b>${this.settings.name}</b> будет удалена без возможности восстановления`,
        onConfirm: () => {
          this.$store
            .dispatch("tablesSettings/removeTableSettings", {
              id: this.id,
            })
            .then(() => {
              this.$router.push({
                name: "tables-settings",
              });
            });
        },
      });
    },

    reset() {
      this.$refs.form.reset();
    },

    submit() {
      const params = this.$refs.form.getParams();

      if (this.id) {
        params.id = this.id;
        this.$store.dispatch("tablesSettings/updateTableSettings", params).then(({ success }) => {
          if (success) {
            this.$notify({
              group: "success-message",
              data: {
                textMessage: `Настройки таблицы <strong>${this.settings.name}</strong> успешно изменены`,
              },
            });
          }
        });
      } else {
        this.$store.dispatch("tablesSettings/createTableSettings", params).then((response) => {
          if (response.success) {
            this.id = response.model.id;
            this.settings = response.model;
            this.$router.push({
              name: "edit-table-settings",
              params: {
                id: response.model.id,
              },
            });
            this.$refs.form.update(response.model);
            this.$notify({
              group: "success-message",
              data: {
                textMessage: `Настройки для таблицы <strong>${this.settings.name}</strong> успешно созданы`,
              },
            });
          } else {
            const { errors } = response;
            if (errors.section) {
              const [firstSection] = errors.section;
              this.error = firstSection;
            }
          }
        });
      }
    },

    toTablesSettings() {
      this.$router.push({
        name: "tables-settings",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";
.table-settings {
  .layout-header {
    margin-bottom: 0;
    align-items: center;
    height: auto;
    min-height: 30px;
  }

  .layout-title {
    padding-right: 20px;
  }

  .table-name {
    font-weight: 400;
  }

  &__note {
    color: $color-label;
    font-size: 12px;
    padding-right: 140px;
    max-width: 940px;
    line-height: 1.2;
    margin-top: 4px;
  }

  &__content {
    margin-top: 24px;
  }

  &__select {
    margin-bottom: 40px;
  }

  &__actions {
    margin-top: 40px;
    position: relative;
    z-index: 2;
  }
  &__reset {
    margin-right: 10px;

    & /deep/ .c-button__wrapper {
      width: 120px;
      padding-left: 0;
      padding-right: 0;
      justify-content: center;
    }
  }
  &__apply {
    & /deep/ .c-button__wrapper {
      width: 125px;
      padding-left: 0;
      padding-right: 0;
      justify-content: center;
    }
  }

  @include onlyStandartMobile {
    .layout-header {
      align-items: flex-start;
    }
    .layout-title {
      padding-top: 6px;
    }
    &__note {
      padding-right: 0;
      margin-top: 10px;
    }
    &__content {
      margin-top: 28px;
    }
  }

  @include onlyMobile {
    &__content {
      padding-bottom: 60px;
    }
    &__actions {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      background: white;

      box-shadow: 0px 0px 15px rgba(8, 20, 45, 0.3);

      &.fixed {
        box-shadow: none;
      }

      & /deep/ {
        .c-button {
          flex-grow: 1;
          width: 50%;
          margin: 0;

          &__wrapper {
            border-radius: 0;
            width: 100%;
          }
        }
      }
    }

    & /deep/ {
      .scroll-top-button {
        bottom: 50px;
      }
    }
  }
}
</style>
